export default __webpack_public_path__ + "static/Tangle2-bfb94d33fc46e70946a3d48aeff5224d.jpg";